export function AlterNav(el) {
    var body = document.body;
    var mainEl = el;
    var bottomEl = el.querySelector('.netset-header-bottom');
    var mobileTrigger = el.querySelector('#navTriggerer');
    var languageTrigger = el.querySelector('.language-container');
    if (!bottomEl) {
        return;
    }
    var config = {
        bottomElHeight: bottomEl.clientHeight,
        classes: {
            sticky: 'sticky',
            animate: 'animate',
            triggered: 'triggered'
        },
        scrollPos: 0,
        breakPoint: 1000,
        mobileTriggered: false,
        languageTriggered: false
    };
    if (!mobileTrigger || window.innerWidth >= config.breakPoint) {
        return;
    }
    mobileTrigger.addEventListener('click', function () {
        if (!config.mobileTriggered) {
            bottomEl.classList.add(config.classes.triggered);
            config.mobileTriggered = true;
            return;
        }
        bottomEl.classList.remove(config.classes.triggered);
        config.mobileTriggered = false;
    });
    var submenuTriggers = bottomEl.querySelectorAll('.empori-header-nav-link > .submenu-trigger');
    if (submenuTriggers) {
        submenuTriggers.forEach(function (trigger) {
            var _a;
            var submenu = (_a = trigger.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
            var triggered = false;
            if (submenu) {
                trigger.addEventListener('click', function (event) {
                    event.preventDefault();
                    if (!triggered) {
                        trigger.classList.add(config.classes.triggered);
                        submenu.classList.add(config.classes.triggered);
                        trigger.textContent = "-";
                        triggered = true;
                        return;
                    }
                    trigger.classList.remove(config.classes.triggered);
                    submenu.classList.remove(config.classes.triggered);
                    trigger.textContent = "+";
                    triggered = false;
                    return;
                });
            }
        });
    }
    if (languageTrigger) {
        languageTrigger.addEventListener('click', function (event) {
            if (!config.languageTriggered) {
                languageTrigger.classList.add(config.classes.triggered);
                config.languageTriggered = !config.languageTriggered;
                return;
            }
            else {
                languageTrigger.classList.remove(config.classes.triggered);
                config.languageTriggered = !config.languageTriggered;
                return;
            }
        });
    }
}
